module.exports = __webpack_public_path__ + "img/flag_black_24dp.29bdd075.svg";